import { Alert } from '@components/Alert';
import React from 'react';

export const ErrorGroup: React.FC<{
    message: string;
    errorName?: string;
    detail?: string;
}> = ({ message, errorName, detail }) => {
    return (
        <div>
            <Alert alertType="error" message={message} detailTitle={errorName} detail={detail} />
        </div>
    );
};
